import fetch from "../helpers/fetch";

const getSubtopics = topicUuid =>
  fetch(`/api/topic/${topicUuid}/subtopics`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }
      throw new Error(`(status code: ${res.status})`);
    })
    .catch(error => {
      throw error;
    });

const postSubtopic = newSubtopic =>
  fetch(`/api/subtopic/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(newSubtopic)
  })
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }
      throw new Error(`(status code: ${res.status})`);
    })
    .catch(error => {
      throw error;
    });

const putSubtopic = ({ uuid, ...subtopicUpdates }) =>
  fetch(`/api/subtopic/${uuid}/update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(subtopicUpdates)
  })
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }
      throw new Error(`(status code: ${res.status})`);
    })
    .catch(error => {
      throw error;
    });

const patchMoveSubtopic = ({ uuid, destinationCodeUuid, moveAbove }) =>
  fetch(`/api/subtopic/${uuid}/move`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({
      destinationCodeUuid,
      moveAbove
    })
  })
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }
      throw new Error(`(status code: ${res.status})`);
    })
    .catch(error => {
      throw error;
    });

const deleteSubtopic = subtopicUuid =>
  fetch(`/api/subtopic/${subtopicUuid}/delete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({})
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw res;
    }
  });

export {
  getSubtopics,
  postSubtopic,
  putSubtopic,
  patchMoveSubtopic,
  deleteSubtopic
};
